import {PersonRole} from '~/utils/types/types'

export const useTableOptions: globalThis.ComputedRef<(totalCount: number) => number[]> = computed(
    () => (totalCount: number) => {
        switch (true) {
            case totalCount <= 10:
                return [10]
            case totalCount <= 15 && totalCount > 10:
                return [10, 15, -1]
            case totalCount <= 50 && totalCount > 15:
                return [10, 15, 50, -1]
            case totalCount <= 100 && totalCount > 50:
                return [10, 15, 50, 100, -1]
            default:
                return [10, 15, 50, 100, -1]
        }
    }
)

export const useIsHasBusinessIntelligenceAccess: globalThis.ComputedRef<boolean> = computed(() => {
    const app = useNuxtApp()

    return (
        app.$conf.public.account.hasBusinessIntelligenceAccess &&
        authStore.hasCorporateAccess &&
        [PersonRole.Supervisor, PersonRole.Director, PersonRole.Support].includes(authStore.personRole)
    )
})

export const useFlagIconCode: globalThis.ComputedRef<(langCode: string) => string> = computed(
    () => (langCode: string) => {
        switch (langCode) {
            case 'en':
                return 'gb'
            case 'ar':
                return 'sa'
            case 'kk':
                return 'kz'
            case 'sq':
                return 'al'
            case 'local':
                return null
            default:
                return langCode
        }
    }
)

export const useWidthForSeatMap = computed(() => (maxCapacity: number | string) => {
    switch (true) {
        case +maxCapacity <= 10:
            return 500
        case +maxCapacity <= 36 && +maxCapacity > 10:
            return 1100
        case +maxCapacity <= 80 && +maxCapacity > 36:
            return 1300
        default:
            return 1600
    }
})
